<template>
  <div class="order">
    <div class="title">
      <span>我的订单</span>
    </div>
    <!-- 订单状态以及搜索 start -->
    <div class="order-head">
      <ul class="head-tab">
        <li @click="checkOrderType(index, item.type)" v-for="(item, index) in orderType" :key="index" :style="orderActive == index ? 'color:#ff9e00' : ''">
          {{ item.name }}
        </li>
      </ul>
      <div class="search">
        <el-input v-model="pageInfo.searchName" @keyup.enter.native="searchOrder" placeholder="输入商品分类，商品名称"></el-input>
        <button class="cur_pointer" @click="searchOrder">搜索</button>
      </div>
    </div>
    <!-- 订单状态以及搜索 end -->

    <!-- 订单列表 start -->
    <div class="table-list">
      <!-- 表头 start -->
      <ul class="table-head">
        <li class="goods">商品</li>
        <li class="price">单价</li>
        <li class="goods_number">数量</li>
        <li class="person">收货人</li>
        <li class="all_price">订单应付金额</li>
        <li class="status">全部状态</li>
        <li class="action">操作</li>
      </ul>
      <!-- 表头 end -->

      <!-- 全选 start -->
      <div class="all-pay" v-if="orderList.length > 0 && orderActive != 5">
        <div class="all">
          <el-checkbox @change="onChangeAll" v-model="isAll">全选</el-checkbox>
        </div>
        <div class="pay" v-if="showAllCanPay && $store.state.allowPay == 1" @click="allPayOrder">
          <span>合并付款</span>
        </div>
      </div>
      <!-- 全选 end -->

      <!-- 展示订单 start -->
      <div class="table-containter" v-loading="loading">
        <template v-if="orderList.length>0">
          <div class="table-content" v-for="(item, index) in orderList" :key="index">
            <ul class="tip">
              <li style="margin-right: 6px">
                <el-checkbox v-if="orderActive != 5" v-model="item.checked" :disabled="(item.orderStatus == 1 && item.payStatus == 1)?false:true" @change="onChangeOrder"></el-checkbox>
              </li>
              <li class="time">{{ item.createTime }}</li>
              <li class="or_num">
                <router-link :to="{path:'/personalCenter/myOrderDetail',query:{id:item.id}}" target="_blank">
                  <span>订单号:</span>
                  <span>{{ item.orderBatchNo }}</span>
                </router-link>
              </li>
            </ul>
            <div class="table_main">
              <!-- 商品 -->
              <div class="all_goods">
                <div class="goods_box" v-for="(v, i) in item.orderGoodsBrandList" :key="i">
                  <div class="show_first" v-if="v.showFirst">
                    <p class="sub_title">
                      {{v.goodsBrandName}}
                    </p>
                    <ul class="goods_content">
                      <!-- 循环商品 -->
                      <li class="goods-info" v-for="(info,infoIndex) in v.goodsMixList" :key="infoIndex">
                        <div class="show_goods" v-if="info.showGoods">
                          <div class="itr">
                            <router-link class="img" :to="info.goodsPath" target="_blank">
                              <img v-lazy="info.mainPreviewImageFilePath" alt="图片加载失败" />
                            </router-link>
                            <router-link class="text" :to="info.goodsPath" target="_blank">
                              <p>{{ info.goodsName+" "+info.goodsMixName }}</p>
                              <p>商品货号:{{ info.goodsMixNo }}</p>
                              <p>商品编号:{{ info.goodsMixSerNo }}</p>
                              <p>商品规格:
                                <span>{{info.attr1ContentName}}</span>
                                <span>{{info.attr2ContentName?'+'+info.attr2ContentName:""}}</span>
                                <span>{{info.attr3ContentName?'+'+info.attr3ContentName:""}}</span>
                                <span>{{info.attr4ContentName?'+'+info.attr4ContentName:""}}</span>
                              </p>
                            </router-link>
                          </div>
                          <div class="price">
                            <span>￥{{ parseInt(info.salePrice) | priceValue }}</span>
                          </div>
                          <div class="num">
                            <span>{{ info.buyCount }}</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="more" v-if="item.showMore">
                  <span class="cur_pointer" @click="addMore(item)">点击加载更多</span>
                </div>
                <div class="more" v-if="item.showReduce">
                  <span class="cur_pointer" @click="reduceMore(item)">点击收起</span>
                </div>
              </div>

              <!-- 操作 -->
              <div class="action_box">
                <div class="name border">
                  <span>{{ item.consignee }}</span>
                </div>
                <div class="payment border">
                  <p><span class="total_price">￥{{parseInt(item.orderTotalFee) | priceValue}}</span></p>
                </div>
                <div class="status border">
                  <p class="canceled" v-if="item.orderCancelApply">
                    <router-link :to="{path:'cancelDetail',query: {id: item.orderCancelApply.id}}" target="_blank">
                      <span>已申请取消</span>
                    </router-link>
                  </p>
                  <p>
                    {{item.orderStatus | filterStatus(item.payStatus,item.deliveryStatus)}}
                  </p>
                  <p>
                    <router-link :to="{path: '/personalCenter/myOrderDetail',query: { id: item.id },}" target="_blank">
                      <span>订单详情</span>
                    </router-link>
                  </p>
                </div>
                <div class="action">
                  <div class="time" v-if="item.orderStatus == 1 && item.payStatus == 1">
                    <img v-lazy="require('@/assets/img/down_time.png')" alt />
                    <count-down :target="item.targetTime" :orderBatchId='item.id' :on-end="onEndHandle" />
                  </div>
                  <div class="pay-btn" v-if="item.orderStatus == 1 && item.payStatus == 1 && item.isCanPay==1 && $store.state.allowPay == 1">
                    <router-link :to="{path:'/payType',query: {id: item.id, orderNo: item.orderBatchNo}}" target="_blank">
                      <span>付款</span>
                    </router-link>
                  </div>
                  <div class="ok-rece com_link" v-if="item.orderStatus == 1 && item.deliveryStatus == 3 && !item.orderCancelApply" @click="cancelOrder(item.id)">
                    取消订单
                  </div>
                  <div class="ok-rece com_link" v-if="item.orderStatus != 3" @click="exportOrder(item.id)">
                    导出订单
                  </div>
                  <div class="ok-rece com_link" v-if="item.orderStatus != 3">
                    <router-link :to="{path:'/printOrder',query: {id: item.id}}" target="_blank">
                      <span>打印订单</span>
                    </router-link>
                  </div>
                  <div class="ok-rece com_link" v-if="item.orderStatus == 1 && (item.deliveryStatus == 5 || item.deliveryStatus == 6)" @click="completeOrder(item.id)">
                    确认收货
                  </div>
                  <div class="ok-rece com_link" @click="buyAgain(item)">
                    再次购买
                  </div>
                  <!-- <div class="ok-rece com_link" >评论</div>
                    <div class="ok-rece com_link" >追加评论</div> -->
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="not-count" v-else>
          <span>暂无订单</span>
        </div>
      </div>
      <!-- 展示订单 end -->

      <div class="page">
        <el-pagination class="pagination" background @current-change="handleCurrentChange" :current-page="pageInfo.pageInfo.pageNumber" :page-size="pageInfo.pageInfo.pageSize" :page-sizes="[1, 5, 10, 15]" @size-change="handleSizeChange" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
      </div>
    </div>
    <!-- 订单列表 end -->
    <!--取消订单-->
    <cancel-order ref="cancel" @refresh="refresh" :GetCancelOrder="GetCancelOrder" :CancelOrder="CancelOrder"></cancel-order>
  </div>

</template>

<script>
const orderType = [
  { type: 0, name: "全部订单" },
  { type: 1, name: "待付款" },
  { type: 2, name: "待发货" },
  { type: 3, name: "待收货" },
  { type: 4, name: "待评价" },
  { type: 5, name: "订单回收站" },
];

import CountDown from "@/components/CountDown";
import CancelOrder from "@/pages/publicView/personalCenter/components/cancelOrder_view.vue";

export default {
  metaInfo: { title: "我的订单 - 个人中心" },
  props: {
    isShopView: {
      type: Boolean,
      default: false,
    },
    GetOrderList: {
      type: Function,
      default: () => {},
    },
    ExportExcel: {
      type: Function,
      default: () => {},
    },
    CompleteOrderBatch: {
      type: Function,
      default: () => {},
    },
    OverTimecancelOrder: {
      type: Function,
      default: () => {},
    },
    GetCancelOrder: {
      type: Function,
      default: () => {},
    },
    CancelOrder: {
      type: Function,
      default: () => {},
    },
    BatchAddShopCart: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      orderType,
      orderList: [],
      orderActive: 0,
      isAll: false,
      total: 1,
      payOrder: [],
      pageInfo: {
        pageInfo: {
          pageNumber: 1,
          pageSize: 5,
          searchProperty: [
            {
              searchFiled: "",
              searchValue: "",
            },
          ],
          orderProperty: [],
        },
        searchName: "",
        queryType: "",
      },
      showAllCanPay: false,
      loading: false,
    };
  },
  components: {
    CountDown,
    CancelOrder,
  },
  mounted() {
    if (this.$route.params.type) {
      this.checkOrderType(this.$route.params.type, this.$route.params.type);
      return;
    }
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      //获取订单列表
      this.GetOrderList(this.pageInfo)
        .then((res) => {
          // console.log("获取订单列表", res);
          if (res.isSuccess == 1) {
            this.orderList = res.data;
            this.orderList.forEach((item) => {
              this.$set(item, "checked", false);
              this.$set(item, "showMore", false);
              this.$set(item, "showReduce", false);
              this.$set(item, "allGoodsList", []);
              this.$set(item, "targetTime", 0);
              let startTime = item.createTime;
              let payExpire = item.payExpire * 1000;
              // ie 不支持 --模式  转为/并且parse为时间戳
              item.targetTime = Date.parse(startTime.replace(/-/g, "/"));
              item.targetTime += payExpire;
              item.orderGoodsBrandList.forEach((v) => {
                this.$set(v, "showFirst", false); // 控制第一层展示
                v.goodsMixList.forEach((count) => {
                  this.$set(count, "showGoods", false); // 控制商品展示
                  this.$set(count, "goodsPath", ""); //商品详情地址
                  if (this.isShopView) {
                    // 不控价店铺空间不需要
                    count.goodsPath = `/sysGoodsDetail/-1/${count.goodsCategorySerNo}/${count.goodsMixSerNo}.html`;
                  } else {
                    count.goodsPath = `/goodsDetails/${count.goodsMixSerNo}.html`;
                  }
                  // 当前订单封装所有商品
                  item.allGoodsList.push(count);
                });
              });
            });
            this.orderList.forEach((item) => {
              if (item.allGoodsList.length > 3) {
                item.showMore = true;
              }
              item.allGoodsList.forEach((v, i) => {
                if (i < 3) {
                  v.showGoods = true;
                }
              });
              item.orderGoodsBrandList.forEach((j) => {
                // 只要一级有展示的商品 就展示一级
                let resItem = j.goodsMixList.find((show) => show.showGoods);
                if (resItem) {
                  j.showFirst = true;
                }
              });
            });
            // 判断是否有支付权限，合并支付
            let resItem = this.orderList.find((v) => v.isCanPay == 1);
            resItem
              ? (this.showAllCanPay = true)
              : (this.showAllCanPay = false);
            // 可支付订单
            this.payOrder = this.orderList.filter(
              (v) => v.orderStatus == 1 && v.payStatus == 1
            );
            //  console.log(this.payOrder)
            this.total = res.count;
            this.loading = false;
          } else {
            this.$message.warning(res.message);
            this.loading = false;
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    cancelOrder(id) {
      this.$refs.cancel.showModal(id);
    },
    //合并付款
    allPayOrder() {
      let orderArr = [];
      this.orderList.forEach((v) => {
        if (v.checked) {
          orderArr.push({
            id: v.id,
            orderNo: v.orderBatchNo,
          });
        }
      });
      if (orderArr.length < 2) {
        this.$alert("请选择至少两条订单", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          showClose: false,
        });
        return;
      }
      // 生成订单 逗号分隔id
      let id = orderArr.map((v) => {
        return v.id;
      });
      // 逗号分隔订单号
      let orderNo = orderArr.map((v) => {
        return v.orderNo;
      });
      id = id.join(",");
      orderNo = orderNo.join(",");
      let newUrl = this.$router.resolve({
        path: "/payType",
        query: { id, orderNo },
      });
      window.open(newUrl.href, "_blank");
    },
    exportOrder(id) {
      // 避免被拦截，先跳转到空白页面
      let tempPage = window.open("", "_blank");
      this.ExportExcel({ orderBatchId: id }).then((res) => {
        // console.log('导出订单',res);
        let downloadFile = res.data[0];
        tempPage.location = downloadFile;
      });
    },
    completeOrder(id) {
      this.$confirm("确认已收货吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.CompleteOrderBatch({ orderBatchId: id }).then((res) => {
            // console.log('确认收货',res);
            this.getList();
          });
        })
        .catch(() => {});
    },
    // 再次购买进购物车
    buyAgain(item) {
      // console.log(item);
      let arr = [];
      item.allGoodsList.forEach((v) => {
        arr.push({
          goodsMixId: v.goodsMixId,
          goodsCount: v.buyCount,
          spaceId: v.spaceId,
        });
      });
      let params = {
        regionCode: localStorage.getItem("_regionCode"),
        shoppingCartList: arr,
      };
      this.BatchAddShopCart(params).then((res) => {
        // console.log("批量加入购物车", res);
        let newUrl = this.$router.resolve(
          this.isShopView ? "/sysShopCart" : "/shopCart"
        );
        window.open(newUrl.href, "_self");
      });
    },
    handleCurrentChange(e) {
      this.pageInfo.pageInfo.pageNumber = e;
      this.isAll = false;
      this.getList();
    },
    handleSizeChange(e) {
      this.pageInfo.pageInfo.pageSize = e;
      this.pageInfo.pageInfo.pageNumber = 1;
      this.isAll = false;
      this.getList();
    },
    //勾选订单
    onChangeOrder(e) {
      var payList = this.orderList.filter((v) => {
        return v.checked == true && v.orderStatus == 1 && v.payStatus == 1;
      });
      // console.log(payList);
      if (this.payOrder.length == payList.length) {
        this.isAll = true;
      } else {
        this.isAll = false;
      }
    },
    //搜索订单
    searchOrder() {
      this.pageInfo.pageInfo.pageNumber = 1;
      this.getList();
    },
    //全选
    onChangeAll() {
      this.orderList.forEach((v, i) => {
        if (this.isAll && v.orderStatus == 1 && v.payStatus == 1) {
          v.checked = true;
        } else {
          v.checked = false;
        }
      });
    },
    checkOrderType(i, type) {
      this.orderActive = i;
      this.pageInfo.queryType = type;
      this.pageInfo.pageInfo.pageNumber = 1;
      this.pageInfo.searchName = "";
      this.isAll = false;
      this.getList();
    },
    refresh() {
      // 取消订单 若是当前页最后一项 则上一页
      if (this.orderList.length === 1) {
        if (this.pageInfo.pageInfo.pageNumber == 1) {
          this.pageInfo.pageInfo.pageNumber = 1;
        } else {
          this.pageInfo.pageInfo.pageNumber--;
        }
      }
      this.getList();
    },
    onEndHandle(id) {
      // console.log(id);
      this.OverTimecancelOrder({ orderBatchId: id }).then((res) => {
        // console.log(res);
        this.getList();
      });
    },
    addMore(item) {
      item.showReduce = true;
      item.showMore = false;
      item.orderGoodsBrandList.forEach((v) => {
        v.showFirst = true;
        v.goodsMixList.forEach((j) => {
          j.showGoods = true;
        });
      });
    },
    reduceMore(item) {
      // 先重置
      item.showReduce = false;
      item.showMore = true;
      item.orderGoodsBrandList.forEach((v) => {
        v.showFirst = false;
        v.goodsMixList.forEach((j) => {
          j.showGoods = false;
        });
      });
      // 再显示
      item.allGoodsList.forEach((v, i) => {
        if (i < 3) {
          v.showGoods = true;
        }
      });
      item.orderGoodsBrandList.forEach((j) => {
        // 只要当前品牌的商品有展示的 就展示品牌
        let resItem = j.goodsMixList.find((show) => show.showGoods);
        if (resItem) {
          j.showFirst = true;
        }
      });
    },
  },
  filters: {
    // a订单状态 b支付状态 c发货状态
    filterStatus(aStatus, bStatus, cStatus) {
      if (aStatus === 1) {
        if (bStatus === 1 || bStatus === 2) {
          return "待付款";
        } else {
          // 付全款了
          if (cStatus == 3) {
            return "待发货";
          }
          // 4部分发货   7发货中
          if (cStatus == 4 || cStatus == 7) {
            return "发货中";
          }
          if (cStatus == 5) {
            return "待收货";
          }
          if (cStatus == 6) {
            return "已收货";
          }
        }
      } else if (aStatus === 2) {
        return "已完成";
      } else if (aStatus === 3) {
        return "已取消";
      } else {
        return "状态异常";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.order {
  .title {
    height: 40px;
    line-height: 40px;
    padding: 0px 31px;
    background: rgba(244, 244, 244, 1);
    span {
      cursor: pointer;
    }
  }
  .order-head {
    height: 74px;
    display: flex;
    justify-content: space-between;
    .head-tab {
      display: flex;
      width: 540px;
      box-sizing: border-box;
      padding-left: 31px;
      justify-content: space-between;
      margin-top: 35px;
      li {
        cursor: pointer;
      }
    }
    .search {
      width: 255px;
      display: flex;
      margin-top: 29px;

      /deep/ .el-input__inner {
        height: 29px;
        font-size: 12px;
        line-height: 29px;
      }
      button {
        width: 50px;
        height: 29px;
        font-size: 12px;
        color: rgba(255, 255, 255, 1);
        background: rgba(144, 144, 144, 1);
      }
    }
  }
  .table-list {
    .all-pay {
      margin-top: 8px;
      height: 31px;
      padding-left: 9px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .pay {
        width: 85px;
        height: 20px;
        border: 1px solid rgba(173, 171, 173, 1);
        border-radius: 8px;
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        margin-left: 44px;
        text-align: center;
        cursor: pointer;
        a {
          display: inline-block;
          width: 100%;
          height: 100%;
          color: rgba(25, 25, 25, 1);
        }
      }
    }
    .table-head {
      height: 30px;
      display: flex;
      border: 1px solid #f4f4f4;
      li {
        flex: 1;
        text-align: center;
        line-height: 30px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(26, 26, 26, 1);
      }
      .goods {
        flex: 5;
        box-sizing: border-box;
        padding-left: 30px;
        text-align: left;
      }
      .price {
        flex: 1.6;
      }
      .goods_number {
        flex: 1;
      }
      .person {
        flex: 2;
      }
      .all_price {
        flex: 2.4;
      }
      .status {
        flex: 2;
      }
      .action {
        flex: 3;
      }
    }
    .table-containter {
      margin: 8px 0px 27px;
      .not-count {
        height: 200px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .table-content {
        border: 1px solid #f4f4f4;
        margin-bottom: 20px;
        .tip {
          display: flex;
          line-height: 30px;
          font-size: 12px;
          padding-left: 8px;
          height: 30px;
          box-sizing: border-box;
          background: #f4f4f4;
          margin-bottom: 26px;
          .time {
            padding: 0 20px;
          }
          .or_num {
            padding: 0 20px;
            a {
              color: #000000;
            }
          }
        }
        .table_main {
          display: flex;
          border-top: 1px solid #f4f4f4;
          .all_goods {
            border-right: 1px solid #f4f4f4;
            flex: 8;
            box-sizing: border-box;
            .goods_box {
              .show_first {
                margin-top: 26px;
                border-top: 1px solid #f4f4f4;
              }
              &:first-child {
                .show_first {
                  margin-top: 0;
                  border-top: none;
                }
              }
              .sub_title {
                text-indent: 50px;
                width: 100%;
                line-height: 26px;
                color: #1a1a1a;
                font-weight: bold;
                font-size: 12px;
              }
              .goods_content {
                padding: 0px;
                box-sizing: border-box;
                .goods-info {
                  font-size: 12px;
                  box-sizing: border-box;
                  &:first-child {
                    .show_goods {
                      padding-top: 26px;
                    }
                  }
                  .show_goods {
                    padding-top: 43px;
                    display: flex;
                    .itr {
                      flex: 5;
                      padding-left: 30px;
                      box-sizing: border-box;
                      display: flex;
                      overflow: hidden;
                      .img {
                        width: 74px;
                        height: 73px;
                        display: block;
                        margin-right: 30px;
                        box-sizing: border-box;
                        cursor: pointer;
                      }
                      .text {
                        max-width: 214px;
                        display: block;
                        color: #000000;
                        &:hover {
                          color: #000000 !important;
                        }
                        p {
                          overflow: hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          margin-bottom: 6px;
                          &:hover {
                            color: @themeColor;
                          }
                        }
                      }
                    }
                    .price {
                      flex: 1.6;
                      text-align: center;
                    }
                    .num {
                      flex: 1;
                      text-align: center;
                    }
                  }
                }
              }
            }
            .more {
              width: 100%;
              border-top: 1px solid #f4f4f4;
              box-sizing: border-box;
              line-height: 30px;
              text-align: center;
              color: #ffaa00;
              font-size: 14px;
            }
          }
          .action_box {
            flex: 9.4;
            box-sizing: border-box;
            display: flex;
            .name,
            .payment,
            .status {
              flex: 2;
              padding-top: 43px;
              box-sizing: border-box;
              text-align: center;
              height: 100%;
            }
            .payment {
              line-height: 20px;
              flex: 2.4;
              .total_price {
                color: #ff0000;
                font-size: 16px;
                font-weight: bold;
              }
              .price {
                color: #ff0000;
              }
            }
            .status {
              .log {
                margin-bottom: 10px;
                color: #000000;
              }
              p {
                color: rgba(255, 170, 32, 1);
                margin-bottom: 10px;
                &:last-child {
                  margin-bottom: 0;
                }
                a {
                  color: #000;
                }
              }
              .canceled {
                font-weight: bold;
                a {
                  color: #e4393c;
                }
              }
            }
            .action {
              flex: 3;
              text-align: center;
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              align-items: center;
              box-sizing: border-box;
              padding-top: 43px;
              .time {
                font-size: 12px;
                font-weight: 400;
                display: flex;
                color: rgba(144, 144, 144, 1);
                margin-bottom: 12px;
                img {
                  width: 15px;
                  height: 16px;
                  margin-right: 10px;
                }
              }
              .pay-btn {
                width: 102px;
                height: 24px;
                border: 1px solid rgba(255, 170, 32, 1);
                text-align: center;
                line-height: 24px;
                margin-bottom: 12px;
                a {
                  width: 100%;
                  display: inline-block;
                  height: 100%;
                  color: @themeColor;
                }
                span {
                  color: rgba(255, 170, 32, 1);
                }
              }

              .ok-order {
                margin-bottom: 10px;
                cursor: pointer;
              }
              .ok-orde,
              .ok-rece {
                font-size: 12px;
                font-weight: 400;
                color: rgba(26, 26, 26, 1);
                margin-bottom: 10px;
                cursor: pointer;
                a {
                  color: rgba(26, 26, 26, 1);
                }
              }
            }
            .border {
              border-right: 1px solid rgba(244, 244, 244, 1);
            }
          }
        }
      }
    }
    .page {
      margin: 0 auto;
      width: 400px;
    }
  }
}
/deep/ .el-loading-spinner {
  top: 15%;
}
</style>